module.exports = __webpack_public_path__ + "static/media/e-truck.4b3182da.jpg";